import { ArticleItem, Basket, BasketItem } from '@egr/wcf/modules/bsk';

export function getArticleItem(eaiwsBasket: Basket, id: string): ArticleItem | null {
    const item: BasketItem | null = eaiwsBasket.getItemById(id);
    if (item instanceof ArticleItem) {
        return item;
    }
    return null;
}